// src/components/GuestSnackbar/GuestSnackbar.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const GuestSnackbar = ({ open, onClose }) => {
    const { t } = useTranslation();

    return (
        <Snackbar open={open} autoHideDuration={15000} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={onClose} severity="info" sx={{ width: '100%', backgroundColor: 'var(--primary-color)', color: 'var(--text-primary-color-white)', '& .MuiAlert-icon': { color: 'var(--text-primary-color-white)' } }} icon={<InfoOutlinedIcon fontSize="inherit" />}>
                {t('guestLimitModal.guestLoginInfo')}
            </Alert>
        </Snackbar>
    );
};

export default GuestSnackbar;